module.exports = __webpack_public_path__ + "static/Portrait-of-Sigurd-min-3e35cba97fa54829112d4f4cf1f642a4.webp";